export interface SpinnerState {
  id: string | string[];
  show: boolean;
  message?: string;
  translateParams?: { [key: string]: string };
}
